export default {
  data() {
    return {
      personnelTypeConst: [
        {label: this.$t('assigned_staff.prestataire'), value: 'PRESTATAIRE'},
        {label: this.$t('assigned_staff.intern'), value: 'INTERN'},
        {label: this.$t('assigned_staff.housekeeper'), value: 'HOUSEKEEPER'},
        {label: this.$t('assigned_staff.partner'), value: 'PARTNER'},
      ],
      personnelTypeFilterConst: [
        {label: this.$t('assigned_staff.prestataire'), value: 'PRESTATAIRE'},
        {label: this.$t('assigned_staff.intern'), value: 'INTERN'},
        {label: this.$t('assigned_staff.housekeeper'), value: 'HOUSEKEEPER'},
      ],
    };
  },
  methods: {
    displayForPersonnelTypeConst(value) {
      let result = this.personnelTypeConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
    displayForPersonnelTypeFilterConst(value) {
      let result = this.personnelTypeFilterConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
  },
};
